/*
 * Models for getting performance data, such as accuracy
 */

define(["backbone", "messaging/messenger", "moment", "configuration/properties"], function (
  Backbone,
  Messenger,
  Moment,
  Properties,
) {
  var TopicPerformanceModel = {};

  TopicPerformanceModel.accuracyModel = Backbone.Model.extend({
    DAYS_BACK: 90, //how many days back should the accuracy go
    idAttribute: "intentId",
    defaults: {
      intentId: 0,
      amount: 0,
    },
    parse: function (response) {
      return response[0]; //data comes back in a list, when we really just need the first element
    },
    url: function () {
      var endDate = Moment().valueOf(); //get current date
      var startDate = Moment().subtract("days", this.DAYS_BACK).valueOf(); //start date is X days ago
      var kbId = Messenger.reqres.request("active:kb");
      return (
        Properties.rootURL +
        "/" +
        kbId +
        "/reports/accuracyTopic/" +
        startDate +
        "/" +
        endDate +
        "/" +
        this.id
      );
    },
  });

  return TopicPerformanceModel;
});
